import { Controller } from "@hotwired/stimulus";

// Toggles a password input between masked and visible, with an accessible button.
export default class extends Controller {
  static targets = ["input", "button", "icon"];
  static values = { showLabel: String, hideLabel: String };

  toggle(event) {
    event.preventDefault();

    const reveal = this.inputTarget.type === "password";
    this.inputTarget.type = reveal ? "text" : "password";
    this.buttonTarget.setAttribute("aria-pressed", String(reveal));
    this.buttonTarget.setAttribute("aria-label", reveal ? this.hideLabelValue : this.showLabelValue);
    this.iconTarget.classList.toggle("bi-eye", !reveal);
    this.iconTarget.classList.toggle("bi-eye-slash", reveal);
  }
}
